import { useMutation, useQueryClient } from '@tanstack/react-query';
import { educationService } from '../services/education.service';
import type { UpdateEducationRequest } from '../types/education.types';

interface UpdateEducationParams {
  candidateId: string;
  educationId: string;
  request: UpdateEducationRequest;
}

export function useUpdateEducation(): {
  updateEducation: (params: UpdateEducationParams) => void;
  isLoading: boolean;
} {
  const queryClient = useQueryClient();

  const { mutate: updateEducation, isPending: isLoading } = useMutation({
    mutationFn: ({ candidateId, educationId, request }: UpdateEducationParams) =>
      educationService.update(candidateId, educationId, request),
    onSuccess: (_data, { candidateId }) => {
      queryClient.invalidateQueries({ queryKey: ['educations', candidateId] });
    },
  });

  return { updateEducation, isLoading };
}
